import {canAccessPagePermission} from "../domains2/adminPermissions/adminPermissionsHelper";
import _ from "lodash";

export const canAccessPageBasedOnPermission = (pagePermission, vuexStore) => canAccessPagePermission(
	pagePermission,
	_.get(vuexStore, "getters.jwtTokenDecoded.permissionGroups", [])
);
